import React, { PureComponent } from 'react';
import { CustomRange } from '../../../common/range';
import {
  formatPercent,
  formatPrice,
  formatTextFloat,
  formatValue,
  formatValueBillion,
} from '../../../helpers/Text';
import Const from '../Const';

class ScreenerRange extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      from: 0,
      to: 0,
      selectedValue: this.props.selectedValue,
      valueRange: this.props.originRange.valueRange,
    };
    this.inputFromRef = React.createRef();
    this.inputToRef = React.createRef();
  }

  initState(props) {
    const { originRange, selectedValue } = props;
    const [min, max] = originRange.valueRange;
    const originFrom = selectedValue[0] < min ? min : selectedValue[0];
    const originTo = selectedValue[1] > max ? max : selectedValue[1];
    const from = this.getFormatParamRange(originFrom, originRange.unit);
    const to = this.getFormatParamRange(originTo, originRange.unit);
    this.setState({ from, to, selectedValue });
  }

  componentDidMount() {
    this.initState(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.initState(nextProps);
  }

  getFormatParamRange = (param, type) => {
    if (type === Const.unitType.BillionVND.key) {
      return formatTextFloat(formatValueBillion(param));
    }
    if (type === Const.unitType.MillionVND.key) {
      return formatTextFloat(formatValue(param));
    }
    if (
      type === Const.unitType.ThousandVND.key ||
      type === Const.unitType.ThousandUnit.key
    ) {
      return formatTextFloat(formatPrice(param));
    }
    if (type === Const.unitType.Unit.key) {
      return formatTextFloat(param);
    }
    if (type === Const.unitType.Percentage.key) {
      return formatPercent(param);
    }
    return formatTextFloat(param, 0);
  };

  getActualValue = (param, type) => {
    if (type === Const.unitType.BillionVND.key) {
      return param * 1000000000;
    }
    if (type === Const.unitType.MillionVND.key) {
      return param * 1000000;
    }
    if (type === Const.unitType.Percentage.key) {
      return param / 100;
    }
    if (
      type === Const.unitType.ThousandVND.key ||
      type === Const.unitType.ThousandUnit.key
    ) {
      return param * 1000;
    }

    return param;
  };

  removeParameter = (param, parameters, changeRange) => {
    const newparam = parameters.filter(p => p.code !== param.code);
    changeRange(newparam);
  };

  onChangeInput = () => {
    const inputValue = this.inputFromRef.current.value.trim();
    if (inputValue.length === 0) {
      this.setState({ from: '' });
    } else {
      this.setState({ from: inputValue });
    }
  };

  onChangeInputTo = () => {
    const inputValue = this.inputToRef.current.value.trim();
    if (inputValue.length === 0) {
      this.setState({ to: '' });
    } else {
      this.setState({ to: inputValue });
    }
  };

  valueOutOfRange(valueRange, value) {
    return value < valueRange[0] || value > valueRange[1];
  }

  onCompleteInput = () => {
    const { originRange, onChange } = this.props;
    const inputValue = this.inputFromRef.current.value.trim();
    const number = inputValue.replace(/,/g, '');
    const numberTo = this.state.to.replace(/,/g, '');
    let actualFrom = originRange.valueRange[0];
    let actualTo = originRange.valueRange[1];
    if (
      inputValue.length > 20 ||
      !number.match(/^[+-]?([0-9]+[.])?[0-9]+$/) ||
      this.valueOutOfRange(
        originRange.valueRange,
        this.getActualValue(Number(number), originRange.unit),
      )
    ) {
      const selectedValue = [
        originRange.valueRange[0],
        this.getActualValue(Number(numberTo), originRange.unit),
      ];
      this.setState({
        from: this.getFormatParamRange(
          originRange.valueRange[0],
          originRange.unit,
        ),
        selectedValue,
      });
    } else if (
      this.getActualValue(Number(number), originRange.unit) >
      this.getActualValue(Number(numberTo), originRange.unit)
    ) {
      actualFrom = this.getActualValue(Number(numberTo), originRange.unit);
      const selectedValue = [Number(numberTo), Number(numberTo)];
      this.setState({
        from: this.getFormatParamRange(numberTo, originRange.unit),
        to: this.getFormatParamRange(numberTo, originRange.unit),
        selectedValue,
      });
    } else {
      actualFrom = this.getActualValue(Number(number), originRange.unit);
      actualTo = this.getActualValue(Number(numberTo), originRange.unit);
      const selectedValue = [Number(actualFrom), Number(actualTo)];

      this.setState({
        from: this.getFormatParamRange(actualFrom, originRange.unit),
        to: this.getFormatParamRange(actualTo, originRange.unit),
        selectedValue,
      });
    }
    onChange([actualFrom, actualTo], originRange);
  };

  pressEnter = e => {
    let charCode = e.which ? e.which : e.keyCode;
    if (e.key === 'Enter') {
      this.onCompleteInput();
    } else {
      if (charCode < 44 || charCode > 57) {
        e.preventDefault();
      }
      return true;
    }
  };

  pressEnterTo = e => {
    let charCode = e.which ? e.which : e.keyCode;
    if (e.key === 'Enter') {
      this.onCompleteInputTo();
    } else {
      if (charCode < 44 || charCode > 57) {
        e.preventDefault();
      }
      return true;
    }
  };

  onCompleteInputTo = () => {
    const { originRange, onChange } = this.props;
    const inputValue = this.inputToRef.current.value.trim();
    const number = this.state.from.replace(/,/g, '');
    const numberTo = inputValue.replace(/,/g, '');
    let actualFrom = originRange.valueRange[0];
    let actualTo = originRange.valueRange[1];
    if (
      inputValue.length > 20 ||
      !numberTo.match(/^[+-]?([0-9]+[.])?[0-9]+$/) ||
      this.valueOutOfRange(
        originRange.valueRange,
        this.getActualValue(Number(numberTo), originRange.unit),
      )
    ) {
      const selectedValue = [
        this.getActualValue(Number(number), originRange.unit),
        originRange.valueRange[1],
      ];
      this.setState({
        to: this.getFormatParamRange(
          originRange.valueRange[1],
          originRange.unit,
        ),
        selectedValue,
      });
    } else if (
      this.getActualValue(Number(numberTo), originRange.unit) <
      this.getActualValue(Number(number), originRange.unit)
    ) {
      actualFrom = this.getActualValue(Number(number), originRange.unit);
      const selectedValue = [Number(actualFrom), Number(actualFrom)];
      this.setState({
        from: this.getFormatParamRange(actualFrom, originRange.unit),
        to: this.getFormatParamRange(actualFrom, originRange.unit),
        selectedValue,
      });
    } else {
      actualFrom = this.getActualValue(Number(number), originRange.unit);
      actualTo = this.getActualValue(Number(numberTo), originRange.unit);
      const selectedValue = [Number(actualFrom), Number(actualTo)];
      this.setState({
        from: this.getFormatParamRange(actualFrom, originRange.unit),
        to: this.getFormatParamRange(actualTo, originRange.unit),
        selectedValue,
      });
    }

    onChange([actualFrom, actualTo], originRange);
  };

  onChangeAndInput = (params, param) => {
    const { onChange } = this.props;
    onChange(params, param);
    this.setState({
      from: this.getFormatParamRange(Number(params[0]), param.unit),
      to: this.getFormatParamRange(Number(params[1]), param.unit),
    });
  };

  render() {
    const { param, parameters, changeRange, originRange } = this.props;

    const [min, max] = originRange.valueRange;
    const { from, to } = this.state;

    return (
      originRange.valueRange.length === 2 && (
        <div style={{ marginBottom: '8px', marginTop: '8px' }}>
          <div className="slider-detail d-inline-flex w-100">
            <div className="text-left text-truncate" title={originRange.name}>
              {originRange.name}
            </div>
            <div className="d-inline-flex justify-content-end pr-10">
              <div className="input-range d-inline-flex mr-10">
                <input
                  className="text-input drop-cus dropdown-toggle"
                  type="text"
                  ref={this.inputFromRef}
                  onChange={this.onChangeInput}
                  onKeyPress={e => this.pressEnter(e)}
                  onBlur={this.onCompleteInput}
                  value={from}
                />
                <span
                  style={{
                    minWidth: '25px',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {' '}
                  {`${Const.unitType[originRange.unit].text} - `}
                </span>
                <input
                  className="text-input drop-cus dropdown-toggle"
                  type="text"
                  onChange={this.onChangeInputTo}
                  onKeyPress={e => this.pressEnterTo(e)}
                  ref={this.inputToRef}
                  onBlur={this.onCompleteInputTo}
                  value={to}
                />
                <span style={{ width: '12px' }}>
                  {' '}
                  {`${Const.unitType[originRange.unit].text}`}
                </span>
              </div>
              <i
                className="icon-cancel text-pointer"
                onClick={() =>
                  this.removeParameter(param, parameters, changeRange)
                }
              />
            </div>
          </div>
          <div className="criteria-slider pl-10 pr-10">
            <CustomRange
              defaultValue={this.state.selectedValue || originRange.valueRange}
              min={min}
              max={max}
              step={0.0001}
              tipFormatter={params => (
                <div className="tooltip-content">
                  {this.getFormatParamRange(params, originRange.unit)}
                </div>
              )}
              onChange={params => this.onChangeAndInput(params, originRange)}
            />
          </div>
        </div>
      )
    );
  }
}

export default ScreenerRange;
